<div class="events-item-container" *ngIf="displayModel" [ngClass]="{ smallScreen: isSmallScreen }">
  <div class="event-time" [ngClass]="{ 'event-in-progress': displayModel.eventType === 'In progress' }">{{ displayModel.eventType }}</div>

  <div class="item-main" [ngClass]="{ selected: selected }">
    <link-indicator
      class="link-indicator"
      *ngIf="displayModel.linkColor"
      [color]="displayModel.linkColor"
      [name]="displayModel.linkName"
    ></link-indicator>
    <div class="events-item-content">
      <div class="title details-container">
        <div
          class="ellipsis"
          [innerHtml]="displayModel.title.text"
          [escape]="false"
          [pTooltip]="displayModel.title.text"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        ></div>
        <result-badge *ngIf="displayModel.badge" [model]="displayModel.badge"></result-badge>
      </div>
      <div class="subtitle details-container">
        <u-icon
          class="meeting-icon"
          *ngIf="displayModel.bullet"
          [model]="displayModel.bullet.icon"
          [pTooltip]="displayModel.bullet.tooltip"
          tooltipPosition="bottom"
          tooltipStyleClass="u-tooltip"
          [styles]="{ 'font-size': displayModel.bullet.id === 'location' ? '12px' : '16px' }"
          (click)="onZoomMeeting(); $event.stopPropagation()"
        ></u-icon>
        <div class="ellipsis" *ngIf="displayModel.time">{{ displayModel.time }}</div>
      </div>
    </div>

    <u-button
      *ngIf="displayModel.joinAction?.id.includes('meeting')"
      class="join-action"
      [ngClass]="{ 'next-event': model.id === soonEvent?.id }"
      (onClick)="onZoomMeeting(); $event.stopPropagation()"
      elementSize="small"
      type="primary"
      [label]="'Join'"
      [escape]="false"
      [pTooltip]="displayModel.joinAction.toolTipText + '&#13; &#13;' + (displayModel.joinAction?.keyBinding | keyIcon)"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    ></u-button>
  </div>
</div>
